import { Fab } from '@/components/elements/forms/buttons';
import Icon from '@/components/icons/Icon';
import { SOCIAL_BUTTON } from './SocialButton.constants';

type SocialButtonProps = (typeof SOCIAL_BUTTON)[keyof typeof SOCIAL_BUTTON] & {
  'aria-label'?: string;
};

const SocialButton = ({ alt, icon, to, 'aria-label': ariaLabel }: SocialButtonProps) => {
  return (
    <Fab
      to={to}
      rel="noreferrer"
      icon={<Icon variant={icon} color="fg_primary" alt={alt} />}
      size="xs"
      target="_blank"
      variant="secondary"
      aria-label={ariaLabel || alt}
    />
  );
};

export default SocialButton;
